// @ts-nocheck
/* eslint-disable */

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.StyledIcon = void 0;

var _styledComponents = _interopRequireWildcard(require('../../styled-components'));

var _colors = require('../../utils/colors');

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc =
            Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }
    newObj.default = obj;
    return newObj;
  }
}

function _templateObject2() {
  var data = _taggedTemplateLiteral([
    '\n  display: flex;\n  align-items: center;\n  svg {\n    width: ',
    ';\n    height: ',
    ';\n    fill: ',
    ';\n  }\n  ',
    '\n'
  ]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(['\n    ', '\n  ']);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}

var disabledStyle = function disabledStyle(props) {
  return (0, _styledComponents.css)(_templateObject(), props.disabled && 'opacity: 0.3;');
};

var StyledIcon = _styledComponents.default.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['width', 'height', 'color', 'disabled'].includes(prop);
  }
})(
  _templateObject2(),
  function (props) {
    return props.width || '1em';
  },
  function (props) {
    return props.height || '1em';
  },
  function (props) {
    return props.color || (0, _colors.normaliseColor)(props.theme.typography.defaultColors, props.theme);
  },
  function (props) {
    return props.disabled && disabledStyle(props);
  }
);

exports.StyledIcon = StyledIcon;
